// Opening the `*_cipher` columns the read endpoints return.
//
// The server stores meanings, observations and link explanations sealed with the user's DEK, exactly
// as it stores entries, so every one of them has to be opened here in the browser. Shared between the
// portrait and links clients because they all face the same two awkward cases: rows written before
// envelope encryption, which are plaintext, and rows we genuinely cannot read.

import { openWithKey } from '../crypto/crypto-vault';

/** Base64 of nonce+ct+tag is at least 28 bytes and never contains spaces. */
export function looksLikeCiphertext(value: string): boolean {
  return !value.includes(' ') && /^[A-Za-z0-9+/=]+$/.test(value) && value.length >= 38;
}

/** Open a ciphertext column, tolerating rows written before envelope encryption. */
export async function openCipher(dek: CryptoKey, value: string | null | undefined): Promise<string> {
  if (!value) return '';
  try {
    return await openWithKey(dek, value);
  } catch {
    // Legacy rows may hold plaintext. Anything else is a row we simply cannot read; returning it
    // raw is wrong, so return nothing and let the UI omit the card.
    return looksLikeCiphertext(value) ? '' : value;
  }
}
